module.exports = __webpack_public_path__ + "img/blog-69.701ce84e.jpg";